<template>
  <div
    v-if="item.qoute"
    :id="item.key"
    class="o-quote"
  >
    <div class="row">
      <div class="col-md-10 offset-md-1">
        <div class="px-md-8" v-html="item.qoute">
          <!-- quote -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Qoute',
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  }
};
</script>
